(() => {
  const initialize = () => {
    const root = document.getElementById('cloudbound-brand-sample');
    const configElement = root?.querySelector('[data-cbx-config]');
    if (!root || !configElement || configElement.dataset.initialized) return;
    configElement.dataset.initialized = 'true';
    const config = JSON.parse(configElement.textContent);
    root.classList.add('cbx-has-js');
    const form = root.querySelector('#CloudboundProductForm');
    const submit = form?.querySelector('.cbx-add');
    const bar = root.querySelector('[data-mobile-buybar]');
    const stickyQuantity = root.querySelector('[data-mobile-quantity]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reducedMotion.matches;
    let stepIndex = 0;
    const crops = [[40,397,373,304],[447,397,360,304],[840,397,373,304],[40,820,373,300],[447,820,360,300],[840,820,373,300]];
    const setText = (selector, value) => { const element = root.querySelector(selector); if (element) element.textContent = value; };
    const photoTrack = root.querySelector('[data-product-photo-track]');
    const photoSlides = Array.from(root.querySelectorAll('[data-product-photo-slide]'));
    const photoButtons = Array.from(root.querySelectorAll('[data-photo-index]'));
    let photoIndex = 0;
    let photoWidth = photoTrack?.clientWidth || 0;
    let photoScrollQueued = false;
    const updatePhoto = () => {
      if (!photoTrack || !photoSlides.length || !photoTrack.clientWidth) return;
      if (Math.abs(photoTrack.clientWidth - photoWidth) > 0.5) {
        photoWidth = photoTrack.clientWidth;
        photoTrack.scrollLeft = photoIndex * photoWidth;
      }
      photoIndex = Math.max(0, Math.min(photoSlides.length - 1, Math.round(photoTrack.scrollLeft / photoWidth)));
      photoTrack.dataset.activeIndex = String(photoIndex);
      photoSlides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== photoIndex)));
      photoButtons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === photoIndex)));
      setText('[data-photo-caption]', photoSlides[photoIndex].dataset.caption);
      setText('[data-photo-number]', `${String(photoIndex + 1).padStart(2, '0')} / ${String(photoSlides.length).padStart(2, '0')}`);
      root.querySelector('[data-photo-previous]').disabled = photoIndex === 0;
      root.querySelector('[data-photo-next]').disabled = photoIndex === photoSlides.length - 1;
      photoScrollQueued = false;
    };
    const goToPhoto = index => {
      if (!photoTrack) return;
      const target = Math.max(0, Math.min(photoSlides.length - 1, index));
      photoTrack.scrollTo({left: target * photoTrack.clientWidth, behavior: reducedMotion.matches ? 'instant' : 'smooth'});
    };
    const onPhotoKey = event => {
      const focusedThumbnail = event.target.closest('[data-photo-index]');
      let target = focusedThumbnail ? Number(focusedThumbnail.dataset.photoIndex) : photoIndex;
      if (event.key === 'ArrowLeft') target--;
      else if (event.key === 'ArrowRight') target++;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = photoSlides.length - 1;
      else return;
      event.preventDefault();
      target = Math.max(0, Math.min(photoSlides.length - 1, target));
      goToPhoto(target);
      if (focusedThumbnail) photoButtons[target]?.focus({preventScroll:true});
    };
    photoTrack?.addEventListener('scroll', () => {
      if (!photoScrollQueued) { photoScrollQueued = true; window.requestAnimationFrame(updatePhoto); }
    }, {passive:true});
    photoTrack?.addEventListener('scrollend', updatePhoto);
    photoTrack?.addEventListener('keydown', onPhotoKey);
    root.querySelector('[data-photo-thumbnails]')?.addEventListener('keydown', onPhotoKey);
    if (photoTrack && 'ResizeObserver' in window) new ResizeObserver(updatePhoto).observe(photoTrack);
    else window.addEventListener('resize', updatePhoto, {passive:true});
    const updateBundle = () => {
      const selected = form?.querySelector('input[name="quantity"]:checked');
      if (!selected) return;
      setText('[data-add-label]', selected.disabled ? config.soldOut : `${config.add} — ${selected.dataset.price}`);
      setText('[data-offer-detail]', selected.dataset.detail);
      setText('[data-mobile-total]', selected.dataset.price);
      setText('[data-mobile-add-label]', selected.disabled ? config.soldOut : config.add);
      if (stickyQuantity) stickyQuantity.value = selected.value;
      submit.disabled = selected.disabled;
      root.querySelector('[data-mobile-add]').disabled = selected.disabled;
    };
    const updateMotion = () => {
      root.querySelectorAll('.cbx-ribbon-track,.cbx-gallery-track').forEach(track => { track.style.animationPlayState = paused ? 'paused' : 'running'; });
      const button = root.querySelector('[data-motion]');
      button?.setAttribute('aria-pressed', String(paused));
      button?.setAttribute('aria-label', paused ? config.play : config.pause);
      setText('[data-motion-label]', paused ? config.play : config.pause);
    };
    const updateGuide = () => {
      const [x,y,width,height] = crops[stepIndex];
      const frame = root.querySelector('[data-guide-frame]');
      const photo = frame?.querySelector('img');
      const step = config.guideSteps[stepIndex];
      if (frame && photo) {
        frame.style.aspectRatio = `${width}/${height}`;
        photo.style.width = `${1254 / width * 100}%`;
        photo.style.left = `${-x / width * 100}%`;
        photo.style.top = `${-y / height * 100}%`;
        photo.alt = step.title;
      }
      setText('[data-guide-count]',config.stepLabel.replace('[number]',String(stepIndex + 1)));
      setText('[data-guide-title]',step.title);
      setText('[data-guide-copy]',step.copy);
      root.querySelectorAll('[data-step]').forEach(button => button.setAttribute('aria-pressed',String(Number(button.dataset.step) === stepIndex)));
      root.querySelector('[data-guide-prev]').disabled = stepIndex === 0;
      setText('[data-guide-next]',stepIndex === 5 ? config.restart : config.next);
    };
    root.addEventListener('change', event => {
      if (event.target.matches('#CloudboundProductForm input[name="quantity"]')) updateBundle();
      if (event.target === stickyQuantity) {
        const selected = form?.querySelector(`input[name="quantity"][value="${stickyQuantity.value}"]`);
        if (selected && !selected.disabled) { selected.checked = true; updateBundle(); }
      }
    });
    root.addEventListener('click', event => {
      const photoButton = event.target.closest('[data-photo-index]');
      if (photoButton) goToPhoto(Number(photoButton.dataset.photoIndex));
      if (event.target.closest('[data-photo-previous]')) goToPhoto(photoIndex - 1);
      if (event.target.closest('[data-photo-next]')) goToPhoto(photoIndex + 1);
      const stepButton = event.target.closest('[data-step]');
      if (stepButton) { stepIndex = Number(stepButton.dataset.step); updateGuide(); }
      if (event.target.closest('[data-guide-prev]')) { stepIndex = Math.max(0,stepIndex - 1); updateGuide(); }
      if (event.target.closest('[data-guide-next]')) { stepIndex = (stepIndex + 1) % 6; updateGuide(); }
      if (event.target.closest('[data-motion]')) { paused = !paused; updateMotion(); }
      const packLink = event.target.closest('[data-select-pack]');
      if (packLink) {
        const input = form?.querySelector(`input[data-pack="${packLink.dataset.selectPack}"]`);
        if (input && !input.disabled) { input.checked = true; updateBundle(); }
      }
    });
    root.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', () => {
      const target = root.querySelector(link.getAttribute('href'));
      if (target?.tagName === 'DETAILS') target.open = true;
    }));
    if (window.location.hash) {
      const target = document.getElementById(window.location.hash.slice(1));
      if (target?.tagName === 'DETAILS') target.open = true;
    }
    let scrollQueued = false;
    const updateBuybar = () => {
      if (bar && submit) {
        const buttonBounds = submit.getBoundingClientRect();
        const viewportHeight = window.visualViewport?.height || window.innerHeight;
        const mainButtonVisible = buttonBounds.top >= 0 && buttonBounds.bottom <= viewportHeight;
        bar.hidden = window.innerWidth > 620 || mainButtonVisible;
      }
      root.classList.toggle('cbx-buybar-visible', Boolean(bar && !bar.hidden));
      scrollQueued = false;
    };
    window.addEventListener('scroll', () => {
      if (!scrollQueued) { scrollQueued = true; window.requestAnimationFrame(updateBuybar); }
    }, {passive:true});
    window.addEventListener('resize',updateBuybar,{passive:true});
    window.visualViewport?.addEventListener('resize', updateBuybar, {passive:true});
    if (submit && 'IntersectionObserver' in window) new IntersectionObserver(updateBuybar, {threshold:[0,1]}).observe(submit);
    reducedMotion.addEventListener('change',event => { paused = event.matches; updateMotion(); });
    updateBundle(); updateGuide(); updateMotion(); updateBuybar(); updatePhoto();
  };
  initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
